import { ExternalLink } from "@brg/ui";
import { SlideNavigationWrapperItem, FlexColumn } from "../../../core/components/verticalNavigation/styles";
import { FC } from "react";
import { CreateLinkTo } from "../../constants/linkTo";
import { useTranslation } from "react-i18next";
import { getTitle } from './documentHelper';


export interface VerticalNavigationArrayProps {
  items: NavItem[];
  getKeyProp: (item: NavItem) => string | number;
  getDisplayProp: (item: NavItem) => string;
  onClick?: (item: NavItem) => void;
  currentlySelectedKey?: string | number;
}

const VerticalNavigationArray: FC<VerticalNavigationArrayProps> = ({
  items,
  getKeyProp,
  getDisplayProp,
  onClick,
  currentlySelectedKey
}) => {

  const { t, i18n: { language } } = useTranslation();

  const onChangeHandler = (item: NavItem) => () => {
    onClick?.(item);
  };

  return (
    <FlexColumn>
      {items.map((item: NavItem) => (
        <ExternalLink
          to={item.link || CreateLinkTo.legalDocument(item.name)}
          target={item.link ? '_blank' : '_self'}
          title={getTitle(item.title, language)}
        >
          <SlideNavigationWrapperItem key={getKeyProp(item)} onClick={onChangeHandler(item)} active={getKeyProp(item) === currentlySelectedKey}>
            {getDisplayProp(item)}
          </SlideNavigationWrapperItem>
        </ExternalLink>
      ))}
    </FlexColumn>
  );
}

export default VerticalNavigationArray;import { ExternalLink } from "@brg/ui";
import { SlideNavigationWrapperItem, FlexColumn } from "../../../core/components/verticalNavigation/styles";
import { FC } from "react";
import { CreateLinkTo } from "../../constants/linkTo";
import { useTranslation } from "react-i18next";
import { getTitle } from './documentHelper';


export interface VerticalNavigationArrayProps {
  items: NavItem[];
  getKeyProp: (item: NavItem) => string | number;
  getDisplayProp: (item: NavItem) => string;
  onClick?: (item: NavItem) => void;
  currentlySelectedKey?: string | number;
}

const VerticalNavigationArray: FC<VerticalNavigationArrayProps> = ({
  items,
  getKeyProp,
  getDisplayProp,
  onClick,
  currentlySelectedKey
}) => {

  const { t, i18n: { language } } = useTranslation();

  const onChangeHandler = (item: NavItem) => () => {
    onClick?.(item);
  };

  return (
    <FlexColumn>
      {items.map((item: NavItem) => (
        <ExternalLink
          to={item.link || CreateLinkTo.legalDocument(item.name)}
          target={item.link ? '_blank' : '_self'}
          title={getTitle(item.title, language)}
        >
          <SlideNavigationWrapperItem key={getKeyProp(item)} onClick={onChangeHandler(item)} active={getKeyProp(item) === currentlySelectedKey}>
            {getDisplayProp(item)}
          </SlideNavigationWrapperItem>
        </ExternalLink>
      ))}
    </FlexColumn>
  );
}

export default VerticalNavigationArray;